<ng-template #regularBtn>
    <shared-link [mobile]="true" class="auth-link" [icon]="icon" [inverted]="inverted" (onClick)="handleClick($event)">
        {{label$ | async}}
    </shared-link>
</ng-template>

<ng-template #desktop>
    <ng-container *ngIf="isAuthorized$ | async">

        <ng-template #loyaltyBox>
            <shared-header type="4" marginTop="none" marginBottom="xs" [center]="true">Hey {{label$ | async}},
            </shared-header>

            <ng-container *ngIf="(showAccountBalance$ | async) === false">
                <shared-loyalty-for-member-program-products [slider]="true" *ngIf="isExpanded">
                </shared-loyalty-for-member-program-products>
            </ng-container>

            <shared-auth-account-balance *ngIf="(showAccountBalance$ | async) === true"></shared-auth-account-balance>
        </ng-template>

        <ng-template #loyaltyOptionTemplate let-item="item">
            {{item?.Name}}
            <shared-badge class="auth-link__badge" size="xs" *ngIf="item?.Counter">{{item?.Counter}}
            </shared-badge>
        </ng-template>

        <shared-drop-down [preContent]="loyaltyBox" [theme]="dropdownTheme" (onToggle)="dropdownToggle($event)"
            (onSelected)="dropdownSelected($event)" projection="global" [options]="options$ | async" position="br"
            mode="menu" [width]="dropdownWidth" [size]="dropdownSize" [optionTemplate]="loyaltyOptionTemplate">

            <shared-link [mobile]="true" class="auth-link" [icon]="icon" [inverted]="inverted">
                {{label$ | async}}
            </shared-link>
        </shared-drop-down>

    </ng-container>

    <ng-container *ngIf="!(isAuthorized$ | async)">
        <ng-container *ngTemplateOutlet="regularBtn"></ng-container>
    </ng-container>

</ng-template>

<ng-template #mobile>
    <ng-container *ngTemplateOutlet="regularBtn"></ng-container>
</ng-template>

<projection-for-device [desktop]="desktop" [mobile]="mobile">
</projection-for-device>